module.exports = __webpack_public_path__ + "static/media/combat(12).4906b53a.PNG";